import { Notification } from './Notification';

export const notificationsHasError = (notifications: Notification[]): boolean =>
  notifications.some((n) => n.type === 'error');
